import { Box } from "@mui/material";

import { useState, useReducer, useEffect } from "react";
import {
	crediCardReducer,
	INITIAL_STATE
} from "../../store/reducer/reducer.creditcard";
import { ACTIONS_TYPES } from "../../store/reducer/reducer.creditcard";

import CreditCardUser from "../../components/credit-card-user";
import CreditCardCard from "../../components/credit-card-confirm-operation";
import CreditCardCardinfo from "../../components/credit-card-cardinfo";
import CreditCardPay from "../../components/credit-card-value-pay";
import CreditCardSucces from "../../components/credit-card-success-op";

import { XyzTransition } from "@animxyz/react";
import "@animxyz/core";

import { createClient } from "../../utils/axios/axios.utils";

import { CARD_INTIIAL_INPUT_VALUES } from "../../store/reducer/reducer.initials";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import moment from "moment";
import axios from "axios";

import {
	addTransaction,
	addCustomer
} from "../../utils/firebase/firebase.datatable";
import { signOutUser } from "../../utils/firebase/firebase";

import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../store/user/user.selector";
import useMediaQuery from "@mui/material/useMediaQuery";

const CreditCard = () => {
	const isNonMobile = useMediaQuery("(min-width: 800px)");
	const user = useSelector(selectCurrentUser);
	const [state, dispatch] = useReducer(crediCardReducer, INITIAL_STATE);
	const [values, setValues] = useState({});
	const [stage, setStage] = useState(0);

	const [valuePay, setValuePay] = useState("");

	const [valuesCard, setValuesCard] = useState(CARD_INTIIAL_INPUT_VALUES);
	const [isValidCardForm, setIsValidCardForm] = useState(false);

	const [payOption, setPayOption] = useState("vista");
	const [times, setTimes] = useState(1);

	const [createUserLoader, setCreateUserLoader] = useState(false);
	const [resetUserForm, setResetUserForm] = useState(false);

	const [productsSell, setProductsSell] = useState([]);
	const [producttoSellList, setProductToSellList] = useState([]);

	const [newPaymentMethod, setNewPaymentMethod] = useState({});
	const [ip, setIP] = useState("");

	const MySwal = withReactContent(Swal);

	const handleSubmitForm = async valuesform => {
		setCreateUserLoader(true);
		console.log("console root: ", valuesform);
		await dispatch({
			type: ACTIONS_TYPES.SET_USER_INFO,
			payload: valuesform
		});
		try {
			const newCust = await addCustomer(
				valuesform.name,
				valuesform.email,
				valuesform.cpfCnpj,
				valuesform.phone
			);
			if (!newCust) {
				signOutUser();
			}
			const newUser = await createClient.post("createclient", null, {
				params: {
					valuesform
				}
			});
			const { status } = await newUser;
			const { data } = await newUser;
			if (status === 200) {
				dispatch({
					type: ACTIONS_TYPES.SET_CREATED_USER,
					payload: data
				});
				setResetUserForm(true);
				setStage(1);
			}
			// console.log(data);
			// setStage(1);
			// console.log("dev mode");
		} catch (error) {
			console.log("error ao gerar o usuário");
			MySwal.fire(
				"Erro ...",
				"Por favor confirmar os dados do usuário!!",
				"error"
			);
		} finally {
			setCreateUserLoader(false);
		}
	};

	const handleChange = e => {
		setValues({ ...values, [e.target.name]: e.target.value });
	};

	const handlerChangeCurrency = event => {
		if (event) {
			const setVal = parseFloat(event.replace(",", ".")).toFixed(2);
			setValuePay(setVal);
		} else {
			setValuePay("");
		}
	};

	useEffect(() => {
		const totalValueCart = productsSell.reduce(
			(total, product) => total + product.valor,
			0
		);
		setValuePay(totalValueCart);
		if(totalValueCart < 60) {
			setPayOption('vista')
		}
	}, [productsSell]);

	const handleStepCardInfo = () => {
		dispatch({
			type: ACTIONS_TYPES.SET_CREDITCARD_INFO,
			payload: valuesCard
		});
		getData();
		setStage(2);
	};

	const handleStep = () => {
		const datetime = new Date();
		const today = moment(datetime).format("YYYY-MM-DD");
		let payOptions;
		if (times > 1) {
			payOptions = {
				installmentCount: times,
				totalValue: valuePay
			};
		} else {
			payOptions = {
				value: valuePay
			};
		}
		let newPayment;
		if (times > 1) {
			newPayment = {
				customer: state.userCreated.id,
				billingType: "CREDIT_CARD",
				dueDate: today,
				totalValue: Number(valuePay),
				description: "paymentFromPitayaPay",
				creditCard: state.creditCard,
				creditCardHolderInfo: state.creditCardHolderInfo,
				remoteIp: ip,
				installmentCount: times
			};
		} else {
			newPayment = {
				customer: state.userCreated.id,
				billingType: "CREDIT_CARD",
				dueDate: today,
				value: Number(valuePay),
				description: "paymentFromPitayaPay",
				creditCard: state.creditCard,
				creditCardHolderInfo: state.creditCardHolderInfo,
				remoteIp: ip
			};
		}
		setNewPaymentMethod(newPayment);
		dispatch({ type: ACTIONS_TYPES.SET_PAY_OPTIONS, payload: payOptions });
		console.log(newPayment);
		setStage(3);
	};

	const handlerCofirmCard = async () => {
		setCreateUserLoader(true);
		try {
			const newPaymentRequest = await createClient.post(
				"createpayment",
				null,
				{
					params: {
						newPaymentMethod
					}
				}
			);
			const { status } = await newPaymentRequest;
			const { data } = await newPaymentRequest;
			if (status === 200) {
				console.log(newPaymentRequest);
				dispatch({
					type: ACTIONS_TYPES.SET_REALIZED_OPERATION,
					payload: data
				});
				setStage(4);
			}
			try {
				await addTransaction(
					user.displayName,
					user.email,
					user.uid,
					"credito",
					valuePay,
					times,
					state.creditCardHolderInfo.email,
					producttoSellList
				);
			} catch (err) {
				console.log("Problema ao salvar transacao no Firebase: ", err);
			}
		} catch (error) {
			console.log("erro ao gerar o pagamento", error);
			MySwal.fire({
				title: "Erro ...",
				text: "Por favor confirmar os dados do pagamento!!",
				icon: "error",
				confirmButtonText: "Revisar"
			}).then(result => {
				if (result.isConfirmed) {
					setStage(1);
				}
			});
		} finally {
			setCreateUserLoader(false);
		}
		// setStage(4);
	};

	const handleInputChangeCard = e => {
		setValuesCard({
			...valuesCard,
			holderName: state.creditCardHolderInfo.name,
			[e.target.name]: e.target.value
		});
	};

	const handleChangePayOptiopn = event => {
		setPayOption(event.target.value);
	};

	const handleChangeTimes = event => {
		setTimes(event.target.value);
	};

	const getData = async () => {
		const res = await axios.get("https://geolocation-db.com/json/");
		setIP(res.data.IPv4);
	};

	useEffect(
		() => {
			const { number, expiryMonth, expiryYear, ccv } = valuesCard;
			if (
				number.length === 16 &&
				expiryMonth.length > 0 &&
				expiryYear.length === 2 &&
				ccv.length === 3
			) {
				setIsValidCardForm(true);
			} else {
				setIsValidCardForm(false);
			}
		},
		[valuesCard]
	);

	useEffect(
		() => {
			console.log("State inside Main Card: ", state);
		},
		[state]
	);

	const handleInputChangeProducts = (event, newValue) => {
		if(event.type === 'click') {
			if(newValue?.codigo){
				setProductsSell([...productsSell, {codigo: newValue.codigo, id: newValue.id, valor: newValue.valor}])
			}
		}
	};

	const handleRemoveProduct = (product, index) => {
		const products = [ ...productsSell]
		products.splice(index, 1)
		setProductsSell(products)
		
	}

	useEffect(() => {
		setProductToSellList(productsSell.map((e) => e.codigo))
	},[productsSell])

	return (
		<Box
			display="flex"
			justifyContent={stage === 2 ? 'start' : 'center'}
			alignItems="center"
			flexDirection="column"
			sx={{
				margin: "0 auto",
				width: !isNonMobile ? "95%" : "50%",
				height: "100%",
				// backgroundColor: "white"
				marginTop: stage === 2 ? '70px' : '0'
			}}
		>
			<XyzTransition appear mode="out-in">
				{stage === 0 &&
					<Box
						sx={{
							width: "100%"
						}}
						xyz="fade ease right-5"
					>
						<CreditCardUser
							handleSubmitForm={handleSubmitForm}
							handleChange={handleChange}
							valuesForm={values}
							createUserLoader={createUserLoader}
							resetUserForm={resetUserForm}
						/>
					</Box>}
				{stage === 1 &&
					<Box
						sx={{
							width: "100%"
						}}
						xyz="fade ease right-5"
					>
						<CreditCardCardinfo
							handleStepCardInfo={handleStepCardInfo}
							state={state}
							valuesCard={valuesCard}
							handleInputChangeCard={handleInputChangeCard}
							isValidCardForm={isValidCardForm}
							setValuesCard={setValuesCard}
						/>
					</Box>}
				{stage === 2 &&
					<Box
						sx={{
							width: "100%"
						}}
						xyz="fade ease right-5"
					>
						<CreditCardPay
							handlerChangeCurrency={handlerChangeCurrency}
							value={valuePay}
							handleStep={handleStep}
							payOption={payOption}
							times={times}
							handleChangePayOptiopn={handleChangePayOptiopn}
							handleChangeTimes={handleChangeTimes}
							setTimes={setTimes}
							handleInputChangeProducts={handleInputChangeProducts}
							productsSell={productsSell}
							handleRemoveProduct={handleRemoveProduct}
						/>
					</Box>}
				{stage === 3 &&
					<Box
						sx={{
							width: "100%"
						}}
						xyz="fade ease right-5"
					>
						<CreditCardCard
							state={state}
							handlerCofirmCard={handlerCofirmCard}
							createUserLoader={createUserLoader}
						/>
					</Box>}

				{stage === 4 &&
					<Box
						sx={{
							width: "100%"
						}}
						xyz="fade ease right-5"
					>
						<CreditCardSucces state={state} />
					</Box>}
			</XyzTransition>
		</Box>
	);
};

export default CreditCard;
